/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Enrollment } from './Enrollment';
import {
    EnrollmentFromJSON,
    EnrollmentFromJSONTyped,
    EnrollmentToJSON,
} from './Enrollment';

/**
 * 
 * @export
 * @interface StudentEnrollmentsResponse
 */
export interface StudentEnrollmentsResponse {
    /**
     * 
     * @type {Array<Enrollment>}
     * @memberof StudentEnrollmentsResponse
     */
    enrollments: Array<Enrollment>;
}

/**
 * Check if a given object implements the StudentEnrollmentsResponse interface.
 */
export function instanceOfStudentEnrollmentsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enrollments" in value;

    return isInstance;
}

export function StudentEnrollmentsResponseFromJSON(json: any): StudentEnrollmentsResponse {
    return StudentEnrollmentsResponseFromJSONTyped(json, false);
}

export function StudentEnrollmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentEnrollmentsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enrollments': ((json['enrollments'] as Array<any>).map(EnrollmentFromJSON)),
    };
}

export function StudentEnrollmentsResponseToJSON(value?: StudentEnrollmentsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enrollments': ((value.enrollments as Array<any>).map(EnrollmentToJSON)),
    };
}

